export default {
    "mobile": 374,
    "tablet": 769,
    "desktop": 1279,
    "xl-desktop" : 1440
  }
